/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Member_Detail_Provisioning_ScimInputs */



/**
* | output |
* | --- |
* | "Provisioned by your identity provider on {date}" |
*
* @param {Member_Detail_Provisioning_ScimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_provisioning_scim = /** @type {((inputs: Member_Detail_Provisioning_ScimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Provisioning_ScimInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Am ${i?.date} von Ihrem Identitätsanbieter bereitgestellt`)
	return /** @type {LocalizedString} */ (`Provisioned by your identity provider on ${i?.date}`)
});